(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var helper = require('./helpers/common.js');
require('./components/search');

helper.equalizer('.home_blocks > div > div p');

require('./pages/all');
require('./pages/home');
require('./pages/categories');
require('./pages/trips/overview');
require('./pages/trips/detail');
require('./pages/contact');

},{"./components/search":2,"./helpers/common.js":3,"./pages/all":7,"./pages/categories":8,"./pages/contact":9,"./pages/home":10,"./pages/trips/detail":11,"./pages/trips/overview":12}],2:[function(require,module,exports){
'use strict';

var helpers = require('../helpers/common.js');
var $pagination = require('../pages/trips/overview/pagination');
var $filters = {
    validator: null,
    container: null,
    init: function init() {
        $filters.container = $('.filters');
        $filters.listeners();
    },
    listeners: function listeners() {
        $filters.container.find('.srch-btn').click(function (e) {
            e.preventDefault();
            $filters.submit();
            return false;
        });

        $filters.container.find('[name="category"]').change($filters.getTags);

        $filters.container.find('[type="number"]').change(function (e) {
            var val = $(this).val() * 1;
            if (val < 0) {
                $(this).val(0);
            }
        });
    },
    getTags: function getTags() {
        //$.post( '/trips/gettags' , { 'category_id' : this.value } , function( data ){
        //    var list = JSON.parse( data );
        //    var select = $filters.container.find( '[name="tag"]' );
        //    select.html( '<option selected="selected" value="">-Selecteer-</option>' );
        //
        //    $filters.flash( select );
        //
        //    list.forEach( function( e ){
        //        select.append( '<option value="' + e.id + '">' + e.title + '</option>' );
        //    } );
        //} );
    },
    flash: function flash(el) {
        el.addClass('flash');
        setTimeout(function () {
            el.removeClass('flash');
        }, 200);
    },
    submit: function submit() {

        $('.overview').addClass('loading');

        clearTimeout($filters.wait);
        $filters.wait = setTimeout(function () {

            $.post('/trips/filter', $filters.container.find('form').serialize()).success(function (data) {

                if ($('.pagination').length <= 0) {
                    $('.overview ').html($(data).filter('.overview').html());
                    $pagination.init();
                } else {

                    $('.overview .two-colls-right').html($(data).find('.two-colls-right').html());
                    $('#results').html($(data).find('#results').text());
                }

                $pagination.set.CurPage();
                $pagination.listeners();
            }).always(function () {
                $('.overview').removeClass('loading');
            });
        }, 300);
    }
};

$filters.init();

},{"../helpers/common.js":3,"../pages/trips/overview/pagination":13}],3:[function(require,module,exports){
'use strict';

var helpers = {};

helpers.goto = function (el) {

    if (el instanceof jQuery === false) {
        el = $(el);
    }

    $("html, body").animate({ scrollTop: el.offset().top - 104 }, 1000); // minus fixed menu
};

helpers.getUrlKey = function (key) {
    key = typeof key != 'undefined' ? parseInt(key) - 1 : false;
    var url = window.location.pathname.substr(1);
    if (key !== false) {
        url = url.split('/');
        if (key in url) {
            return url[key];
        }
        return false;
    }
    return url;
};

helpers.equalizer = function (selector) {
    var self = this;
    var elements = $(selector);

    function equalize() {
        var height = 0;
        elements.css('height', 'auto').each(function () {
            var elHeight = $(this).outerHeight();
            height = height < elHeight ? elHeight : height;
        });
        elements.outerHeight(height);
    };

    equalize();
    $(window).resize(function () {
        equalize();
    });
};

helpers.post = function (path, params, method) {
    method = method || "post"; // Set method to post by default if not specified.

    // The rest of this code assumes you are not using a library.
    // It can be made less wordy if you use one.
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            var hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", key);
            hiddenField.setAttribute("value", params[key]);

            form.appendChild(hiddenField);
        }
    }

    document.body.appendChild(form);
    form.submit();
};

module.exports = helpers;

},{}],4:[function(require,module,exports){
'use strict';

var $device = {

    types: ['lg', 'md', 'sm', 'xs'],
    widths: [1200, 992, 768, 0],

    type: function type() {
        var type;
        $.each($device.widths, function (key, value) {

            if (value < $device.width()) {
                type = $device.types[key];
                return false;
            }
        });
        return type;
    },

    width: function width() {
        return $(window).width();
    },

    deviceWidth: function deviceWidth(type) {
        var index = $device.types.indexOf(type);
        return $device.widths[index];
    },

    isMobile: function isMobile() {
        if ($device.type() == 'xs') {
            return true;
        }
        return false;
    }

};

module.exports = $device;

},{}],5:[function(require,module,exports){
'use strict';

var $notice = require('../objects/Notice');
function Form(container, ajax) {
    var self = this;
    self.form = container;
    self.valid = true;
    self.csrf = false;
    self.url = '';
    self.ajax = ajax || false;

    var scrollOffset = 200;

    self.init = function () {

        if (this.form instanceof jQuery === false) {

            throw new Error("Container is not a jquery instance");
        }

        self.listeners();
        self.url = container.attr('action');
    };

    self.listeners = function () {

        $(self.form).on('submit', self.onSubmit);
        self.form.find('input[data-validate][type="text"]').each(function () {
            $(this).on('blur', function () {
                self.checkRules(this);
            });
        });

        self.form.find('input[data-validate][type="checkbox"] , ' + '            input[data-validate][type="radio"] , ' + '            select').each(function () {
            $(this).on('change', function () {
                self.checkRules(this);
            });
        });
    };

    self.checkRules = function (input) {

        var rules = $(input).data('validate').split('|');
        var required = rules.indexOf('req');
        if (required > -1) {

            rules.splice(required, 1);
            if (input.type == 'radio' || input.type == 'checkbox') {
                if (self.isChecked(input)) {
                    return false;
                }
            } else if (self.isRequired(input)) {
                return false;
            }
        }

        rules.forEach(function (rule) {
            self.validate(input, rule, required > -1);
        });
    };

    self.isRequired = function (input) {
        var value = $(input).val().trim();
        if (value.length === 0) {
            $(input).addClass('error');
            self.valid = false;
        } else {
            $(input).removeClass('error');
        }
    };

    self.isChecked = function (input) {
        if (!input.checked) {
            $(input).closest('.' + input.type).addClass('error');
            self.valid = false;
        } else {
            $(input).closest('.' + input.type).removeClass('error');
        }
    };

    self.validate = function (input, rule, required) {

        var value = $(input).val().trim();
        if (!rule) {
            return false;
        }

        if (!required && value.length === 0) {

            $(input).removeClass('error');
            return false;
        }

        switch (rule) {

            case 'email':
                var emailReg = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
                var valid = emailReg.test(value);

                if (!valid) {
                    $(input).addClass('error');
                    self.valid = false;
                } else {
                    $(input).removeClass('error');
                }
                break;

            case 'phone':
                var myString = value.replace(/[^\d\+]/g, "");
                if (myString.length < 10) {
                    $(input).addClass('error');
                    self.valid = false;
                } else {
                    $(input).removeClass('error');
                }
                break;

            case 'zip':

                var myString = value.replace(/[^A-Za-z0-9?]/g, "");
                if (myString.replace(/[^0-9?]/g, "").length != 4 || myString.replace(/[^A-Za-z?]/g, "").length != 2) {
                    $(input).addClass('error');
                    self.valid = false;
                } else {
                    $(input).removeClass('error');
                }

                break;
        }
    };

    self.isValid = function () {
        console.log(self.valid);
        return self.valid;
    };

    self.onSubmit = function (e) {

        self.valid = true;
        self.form.find('[data-validate*="req"]').change().blur();

        if (!self.isValid()) {
            self.toTop(self.form.find('.error').first().offset().top);
            self.form.trigger("custom:invalid");
            return false;
        }

        self.setCsrfToken();

        self.form.trigger('custom:beforeSend'); //send event for some object to be able to clean up

        return self.submit();
    };

    self.post = {
        clear: function clear() {
            if (typeof self.notice != 'undefined') {
                self.notice.remove();
            }
        },
        success: function success(res) {
            self.notice = $notice.success(res);
            self.form.before(self.notice);

            self.form.slideUp(function () {
                self.form.remove();
                self.toTop(self.notice.offset().top);

                self = null;
            });
        },
        error: function error(res) {
            self.notice = $notice.error(res.responseText);
            self.form.before(self.notice);
            self.toTop(self.notice.offset().top);
        }
    };

    self.toTop = function (goto) {
        $("html, body").animate({ scrollTop: goto - scrollOffset }, 1000);
    };

    self.setCsrfToken = function () {
        if (!self.csrf) {
            self.form.append('<input type="hidden" name="antispam" value="' + new Date().getTime() + '" />');
            self.csrf = true;
        }
    };

    self.init();
}

Form.prototype.submit = function () {
    var self = this;
    if (self.ajax) {
        $.post(self.url, self.form.serialize()).always(self.post.clear).success(self.post.success).error(self.post.error);

        return false;
    }
};

module.exports = Form;

},{"../objects/Notice":6}],6:[function(require,module,exports){
'use strict';

module.exports = {
    make: function make(text, type) {
        return $('<div></div>').addClass('notice ' + type).html(text);
    },
    error: function error(text) {
        return this.make(text, 'error');
    },
    success: function success(text) {
        return this.make(text, 'success');
    }
};

},{}],7:[function(require,module,exports){
'use strict';

var $form = require('../objects/Form');
(function () {

    new $form($("#newsletter_form"), false);

    $('#totop').click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, "slow");
    });

    var slider = document.getElementById('price');
    if (slider != null) {
        noUiSlider.create(slider, {
            start: [$(slider).data('min'), $(slider).data('max')],
            connect: true,
            step: 1,
            range: {
                'min': [$(slider).data('min')],
                'max': [$(slider).data('max')]
            },
            format: wNumb({
                decimals: 0
            })
        });

        slider.noUiSlider.on('update', function (values, handle) {
            $(".min-price").val(values[0]).html('&euro; ' + values[0]);
            $(".max-price").val(values[1]).html('&euro; ' + values[1]);
        });
    }

    $('table').each(function (obj) {

        $(this).width('100%');

        var tds = $(this).find('td');

        tds.each(function () {

            $(this).width(100 / tds.length + '%');
        });
    });

    $('.info').click(function () {
        $(this).toggleClass('open');
    });
})();

},{"../objects/Form":5}],8:[function(require,module,exports){
'use strict';

(function () {
    'use strict';

    if ($('#categories').length <= 0) return false;

    $(document).ready(function () {
        var $container = $('.portfolio-four-colls');
        $container.isotope({
            itemSelector: '.portfolio-i',
            columnWidth: 520,
            rowHeight: 220
        });

        $('.portfolio-filters li a').on('click', function () {
            var $sort = $(this).data('sort');
            if ($sort == 'all') {
                var $sort = '*';
                $container.isotope({ filter: $sort });
            } else {
                $container.isotope({ filter: '.' + $sort });
            }
            $('.portfolio-filters li').removeClass('active');
            $(this).closest('li').addClass('active');
            return false;
        });
    });
})();

},{}],9:[function(require,module,exports){
'use strict';

var $form = require('../../objects/Form');
var $device = require('../../helpers/device');
//contact_form
$(document).ready(function () {
    'use strict';

    if ($("#contact_form").length <= 0) return false;

    new $form($("#contact_form"), true);
});

},{"../../helpers/device":4,"../../objects/Form":5}],10:[function(require,module,exports){
"use strict";

},{}],11:[function(require,module,exports){
'use strict';

var $form = require('../../../objects/Form');
var $helpers = require('../../../helpers/common');
$(document).ready(function () {
    'use strict';

    if ($('#map').length <= 0) return false;

    new $form($("#information"), true);
    new $form($("#reservation"), true);

    $('#gallery').bxSlider({
        infiniteLoop: true,
        speed: 500,
        slideWidth: 108,
        minSlides: 1,
        maxSlides: 6,
        moveSlides: 1,
        auto: false,
        slideMargin: 7
    });

    var $maps = {

        init: function init() {
            var myLatlng = new google.maps.LatLng($trip.lat, $trip.long);
            var mapOptions = {

                zoom: 9,
                center: myLatlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };

            var image = new google.maps.MarkerImage('/_img/icons/map.png', new google.maps.Size(19, 29), new google.maps.Point(0, 0), new google.maps.Point(0, 32));

            var map = new google.maps.Map(document.getElementById('map'), mapOptions);
            var marker = new google.maps.Marker({
                icon: image,
                position: myLatlng,
                map: map,
                title: $trip.title
            });
        }
    };
    $maps.init();

    $('.btnShow').click(function () {
        $(this).next().slideDown('slow');
        return false;
    });

    $('.stat[data-type="call"]').click(function () {
        $(this).fadeOut();
    });

    var $stats = {

        listeners: function listeners() {
            $('.stat').click($stats.send);
        },
        send: function send() {
            var type = $(this).data('type');
            console.log($helpers.getUrlKey(2));
            $.post('/trips/addStat/' + $helpers.getUrlKey(2) + '/' + type, function (data) {
                console.log(data);
            });
        }
    };
    $stats.listeners();

    $('.datepicker').datepicker({
        dateFormat: "dd-mm-yy",
        monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
    });
});

},{"../../../helpers/common":3,"../../../objects/Form":5}],12:[function(require,module,exports){
'use strict';

var $pagination = require('./pagination');

$pagination.init();

},{"./pagination":13}],13:[function(require,module,exports){
'use strict';

var $device = require('../../../helpers/device.js');
var $pagination = {
    maxPage: 1,
    page: 1,
    order: '',
    amount: '',
    init: function init() {

        $pagination.set.MaxPage();
        $pagination.set.CurPage();

        var pagination = $('.catalog-head');
        $pagination.set.order.call(pagination.find('[name="order"]'), false);
        $pagination.set.amount.call(pagination.find('[name="amount"]'), false);
        $pagination.listeners();
    },
    set: {
        CurPage: function CurPage() {
            var current = $('.current-page').html() * 1;
            console.log(current);
            $pagination.page = current || 1;
        },
        MaxPage: function MaxPage() {
            $pagination.maxPage = $('.max-page').html();
        },
        order: function order(fetch) {

            fetch = fetch !== false;

            $pagination.order = $(this).val();
            if (fetch) {

                $pagination.fetch();
            }
        },
        amount: function amount(fetch) {

            fetch = fetch !== false;

            $pagination.amount = $(this).val();
            if (fetch) {

                $pagination.fetch();
            }
        }
    },
    listeners: function listeners() {
        var pagination = $('.catalog-head');
        pagination.find('.prev').click($pagination.fetchPrev);
        pagination.find('.next').click($pagination.fetchNext);
        pagination.find('[name="order"]').change($pagination.set.order);
        pagination.find('[name="amount"]').change($pagination.set.amount);
        $pagination.slideHover();
    },

    slideHover: function slideHover() {
        if ($device.isMobile()) return;
        $('.offer-slider-i').on({

            mouseenter: function mouseenter() {
                $(this).find('.offer-slider-overlay').fadeIn(170);
                $(this).find('.offer-slider-btn').animate({ top: "50%" }, 170);
            },
            mouseleave: function mouseleave() {
                $(this).find('.offer-slider-overlay').fadeOut(170);
                $(this).find('.offer-slider-btn').css('top', '-200px');
            }
        }, $(this));
    },

    fetchNext: function fetchNext(e) {

        e.preventDefault();
        if ($(this).hasClass('disabled')) return false;
        $('.prev').removeClass('disabled');

        $pagination.page += 1;
        if ($pagination.page >= $pagination.maxPage) {
            $('.next').addClass('disabled');
        }

        $pagination.fetch();
    },
    fetchPrev: function fetchPrev(e) {

        e.preventDefault();
        if ($(this).hasClass('disabled')) return false;
        $('.next').removeClass('disabled');

        $pagination.page -= 1;
        if ($pagination.page <= 1) {
            $('.prev').addClass('disabled');
        }

        $pagination.fetch();
    },
    fetch: function fetch() {

        $('.current-page').html($pagination.page);
        $('.overview').addClass('loading');
        clearTimeout($pagination.wait);
        $pagination.wait = setTimeout(function () {

            $.post('/trips/fetch', { order: $pagination.order, page: $pagination.page, amount: $pagination.amount }).success(function (data) {
                $('.overview .two-colls-right').html($(data).find('.two-colls-right').html());
                $pagination.set.CurPage();
                $pagination.listeners();
            }).always(function () {
                $('.overview').removeClass('loading');
            });
        }, 300);
    }
};

module.exports = $pagination;

},{"../../../helpers/device.js":4}]},{},[1]);
